// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__k+WZX","loader":"Loader_loader__k+xS9","pulse":"Loader_pulse__tYLYP","scaleUp":"Loader_scaleUp__Vrcwy"};